var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/linear/refresh-circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10A10 10 0 1 1 10 0a10 10 0 0 1 10 10z",
    transform: "translate(2 2)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18693"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.321A1.787 1.787 0 0 0 3.25 1.5 1.787 1.787 0 0 0 1.5 3.321 1.819 1.819 0 0 0 2.668 5.04 1.9 1.9 0 0 1 4 6.75a.75.75 0 0 1-1.5 0 .182.182 0 0 0-.061-.118.735.735 0 0 0-.287-.184A3.319 3.319 0 0 1 0 3.321 3.286 3.286 0 0 1 3.25 0 3.286 3.286 0 0 1 6.5 3.321a.75.75 0 0 1-1.5 0z",
    transform: "translate(8.75 6.625)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M1 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1z",
    transform: "translate(11 15.375)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.7068ff75b29aad45d26ea3944674c1d7.svg";
export { ForwardRef as ReactComponent };